import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    id="Layer_15"
    data-name="Layer 15"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 450 300"
    {...props}>
    <defs>
      <style>{'.cls-1{fill:#fff}'}</style>
    </defs>
    <path
      className="cls-1"
      d="M410.31 134.75c-3.33 0-5.49 2.14-9.42 3.37-5.07 1.58-11.55 1.54-16 2.46-1.63-.48-3.3-.94-5-1.33-17.3-4-8-2.15-16.39-4.76a21.33 21.33 0 0 1-3.88-2.13l-33.66-21c-1-.54-2.45-.89-3.8-1.43.79-2.28 1.4-4 1.4-4.11a40.25 40.25 0 0 0-1.73-7.27c.52-.27.83-.57.83-.89 0 0-2-2.74-2-12.44 0-3.83.65-7.56.65-11.36S317.06 60 311.15 56c2.74-1.88 5.37-5 5.76-10.91.92-1.33 1.75-2.72 1.75-3.72 0-.36-4-15.1-18.51-16.36-10.15 3.82-14.52 6.93-14.52 15.79 0 .89 0 2.25.13 3.79a10.82 10.82 0 0 0-2.5-.45c-5 0-10.12-.39-15.18-.39-21.42 0-29.46 11.09-37.72 18.15.15 1 .34 2 .55 3-3.68 2.43-10.72 9-22.63 27-.83.61-1.68 1.24-2.6 1.81-4.4 2.76-9.16 5.86-9.16 13.59a57.73 57.73 0 0 0 1.7 8.77 1.5 1.5 0 0 0 .6.13c1.47 0 2.22-2.63 2.57-4.79a12.85 12.85 0 0 0 2.94 1.45c.3 0 .59-.09.84-.09.63 0 2 1.22 3.6 2a3.09 3.09 0 0 0 .58-1.68 5.71 5.71 0 0 0-1.69-3.28c5.6-5 4.79-6.65 4.79-10.67v-1.59c0-6.16 17.67-11.62 26.07-23.1a4.92 4.92 0 0 1 1 .73c1.64-.28 3.39-.57 5.24-.81-3.33 17.41-9.23 40.89-9.23 40.89 0 9.83.89 13.24 12.61 21.51a6.53 6.53 0 0 0 1.8.83c-3.49 11.87-5.19 4.86-5.19 20 0 8.09 3.89 11.42 6.05 14.42 2.1.59 4 1.2 5.79 1.8a31.62 31.62 0 0 1-.07 6.82 36.53 36.53 0 0 1-2.17 5 .35.35 0 0 1 0-.1c0 .75-2.09 2.86-2.81 3.76-18.53 23.15-3.26 28.16-18.53 49.18-3.11 4.29-5.57 6-6.89 8.45a9.34 9.34 0 0 0-1.24 3.61c0 4.11 8.72 8.06 14.71 12.18 7 15.07 12.24 11.29 17.9 13.91a6.27 6.27 0 0 0 1.73-4c0-4-8.41-13.26-12.07-20.77 2.07-23.52-1.9-8.42 17.4-43.41 0 0 5.77-10 6.68-11.63 3.76-2.75 5.54-10.06 6.76-15.9h.53c2.67 0 4.4-.08 5.63-.18-.07-.75-.13-1.5-.13-2.25l3.75-24.93c0-2.58-.42-3.31-.42-4.64a33.88 33.88 0 0 1 1.53-7.43c10 0 4.94 3.22 16 3.22h2.09c1.3-1.5 2.3-3.09 2.3-4.43 0 0 0-.49-.05-1.2a17.22 17.22 0 0 0 8.81-9.18c19.38 21.75 31.32 10.56 47.1 19.7 2 1.17 4 2.42 5.66 3.53 2.59 6.2 4.86 12.36 10.6 12.36a12.45 12.45 0 0 0 4.12-.86c1.89-1.89 3.63-4.6 6.34-7.47 5.93-6.28 23.05-8.48 23.33-20.95-1.11-1.3-2.52-1.46-4.87-1.46ZM308 106.41a27.81 27.81 0 0 0-1.79-4.33 6.44 6.44 0 0 0-.75 0c-6 0-12.72-4.28-17.38-4.28a10.66 10.66 0 0 0-1.64.11c1.86-2.73 5-3.25 8.38-5.56 2.57-1.74 1.68-4.15 7-5.46.74 7.07-1.69 13.16 7.55 13.53-.37 1.58-1.24 3-1.37 5.99Zm116.81-22.73a18.59 18.59 0 1 0 18.59 18.58 18.57 18.57 0 0 0-18.59-18.58Z"
    />
    <rect className="cls-1" x={27.2} y={101.9} width={167.49} height={96.2} rx={48.1} />
    <text
      transform="translate(62.98 175.21)"
      style={{
        fontSize: '74.09px',
        fill: '#010f37',
        fontFamily: 'Rubik-Bold,Rubik',
        fontWeight: 700,
        letterSpacing: '-.01em'
      }}>
      {'S'}
      <tspan
        x={48.61}
        y={0}
        style={{
          letterSpacing: '-.02em'
        }}>
        {'T'}
      </tspan>
    </text>
  </svg>
);

export default SvgComponent;
